import { render, staticRenderFns } from "./account-script.vue?vue&type=template&id=c50906a8"
import script from "./account-script.vue?vue&type=script&lang=js"
export * from "./account-script.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports